import React from 'react';

const Button = ({ label, onClick, style, className, type = 'button' }) => {
  return (
    <button type={type} onClick={onClick} className={className} style={style}>
      {label}
    </button>
  );
};

export default Button;
